import { Box } from '@mui/material';
import { WorkspacePremium } from '@mui/icons-material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

function BreakthroughBadge(props) {
  const { iconSX, showFixedBG } = props;
  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: '#ffffff',
      '&:before': {
        border: '1px solid #E6EDFF',
        boxShadow: '0px 1px 10px 0px #E6EDFE',
      },
    },
    [`& .${tooltipClasses.tooltip}`]: {
      color: '#232B35',
      padding: '10px',
      backgroundColor: '#ffffff',
      borderRadius: '10px',
      border: '1px solid #E6EDFF',
      boxShadow: '0px 1px 10px 0px #E6EDFE',
      fontSize: 12,
    },
  }));

  return (
    <CustomTooltip
      title="Top Contributors have been recognized for outstanding contributions in the boardroom and may get priority access to additional perks & benefits."
      arrow
      placement="left"
    >
      <WorkspacePremium
        sx={{
          position: 'absolute',
          left: '26px',
          top: '10px',
          zIndex: 3,
          width: '31px',
          height: '31px',
          color: '#EFBF04',
          ...iconSX,
        }}
      />
      {showFixedBG && (
        <Box
          sx={{
            position: 'absolute',
            left: '34px',
            top: '15px',
            backgroundColor: 'white',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            zIndex: 2,
          }}
        />
      )}
    </CustomTooltip>
  );
}

export default BreakthroughBadge;
